import Clickable from "@components/clickable"
import moreImage from "@images/newGames/ALL.png"
import React from "react"
import styles from "./games.module.scss"

const Games = ({ games, onMoreClick }) => {
  return (
    <div className={styles.grid}>
      {games.map(({ id, thumb }) => {
        return (
          <Clickable
            key={id}
            {...(id !== "more"
              ? {
                  appNavTo: `https://www.gcores.com/games/${id}`,
                }
              : {
                  onClick: () => {
                    if (onMoreClick) {
                      onMoreClick()
                    }
                  },
                })}
          >
            <div
              style={{
                backgroundImage: `url(${id === "more" ? moreImage : thumb})`,
              }}
            />
          </Clickable>
        )
      })}
    </div>
  )
}

export default Games
